<template>
  <div class="box box--file2">
    <div class="box-img-wrapper">
      <ImageWrapper v-if="box.idImage" :file="box.idImage" :key="box.idImage" />
      <div class="file-icon" v-else>
        <img  src="../../assets/images/file_icon.svg">
      </div>
    </div>
    <div class="box-inner">
      <span class="box-tag2">
        <span class="box-file-type">
          <i :class="`icon-file-${box.type}`"></i>
          {{box.type}}
        </span>
        <span>{{box.humanSize}}</span>
        <span class="box-date" v-if="isDateValid(box.publishDate)">{{box.publishDate | formatDate2}}</span>
        <span class="box-date" v-else>{{box.createdAt | formatDate2}}</span>
      </span>
      <a class="box-title" target="_blank" :href="`https://engage.edge.capgemini.com/api/filepreview/${box.idFile}`"><span>{{box.name}}</span></a>
      <div class="box-bottom2">
        {{box.fileDescription}}
      </div>
      <div class="box-menu">
        <button class="box-menu-button" @click="showMenu = ! showMenu"><i class="icon-more"></i></button>
        <transition name="fade">
          <div class="box-menu-dropdown" v-if="showMenu">
            <a class="link-icon" @click="showMenu = false" target="_blank" :href="`https://engage.edge.capgemini.com/api/filepreview/${box.idFile}`"><i class="icon-eye"></i> <span>Preview</span></a>
            <a class="link-icon" @click="showMenu = false"  download :href="`https://engage.edge.capgemini.com/api/file/${box.idFile}`"><i class="icon-download"></i> <span>Download</span></a>
            <!--<a class="link-icon"><i class="icon-send"></i> <span>Email</span></a>-->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import moment from "moment-timezone";
export default {
  name: "CompanyFileBox",
  components: {ImageWrapper},
  props: ['box'],
  data () {
    return {
      showMenu: false
    }
  },
  methods: {
    isDateValid(date) {
      return moment(date).isValid()
    }
  }
}
</script>
